/*
Muestra la barra de búsqueda 
y el botón Crear de arriba a la derecha.
Autor: Benjamín León
Fecha: 2024-01-08
*/
import React from 'react'
import { useNavigate } from 'react-router-dom'

import { AppPath } from '../enums/AppPath'
import { useAuth } from '../hooks/useAuth'
import { PageState } from '../interfaces/PageState'

import { ButtonAction } from './Buttons'

interface CardOneSearchProps {
  headerText: string
  docuType: string
  searchTerm: string
  setSearchTerm: (e: string) => void
  showCreaButton?: boolean
  onCreateClick?: () => void
  onClearClick: () => void
  toolBar?: React.ReactNode
  pageState?: PageState
}

const CardOneSearch: React.FC<CardOneSearchProps> = ({
  headerText,
  docuType,
  searchTerm,
  setSearchTerm,
  showCreaButton = true,
  onCreateClick,
  onClearClick,
  toolBar,
  pageState,
}) => {
  const { setSelectedPair } = useAuth()
  const navigate = useNavigate()

  let placeholder = 'Buscar por cliente o vehículo'
  let goTo = `/selection/${docuType}`
  let crearButton = true

  const handleClear = () => {
    setSearchTerm('')
    onClearClick()
  }

  const handleCrear =
    onCreateClick ||
    (() => {
      // inicializamos el par solo si estamos creando una nueva
      // comnsignacion, cotizacion, etc
      if (docuType !== AppPath.Vehicles && docuType !== AppPath.Clients) {
        setSelectedPair({ vehicleId: '', clientId: '' })
      }

      if (docuType === AppPath.Vehicles) {
        navigate(goTo, { state: { mode: false, pageState } })
      } else {
        navigate(goTo)
      }
    })

  switch (docuType) {
    case AppPath.Consignments:
      break

    case AppPath.Estimates:
      headerText += 'Cotizaciones'
      break

    case AppPath.SaleNotes:
      headerText += 'Notas de venta'
      break

    case AppPath.Settlements:
      headerText += 'Liquidaciones'
      goTo = `/${AppPath.Consignments}/${docuType}` // ???
      break

    case AppPath.Clients:
      //  headerText += "Clientes";
      placeholder = 'Buscar por cliente'
      goTo = `/${AppPath.Clients}/edit/0`
      break

    case AppPath.Purchases:
      headerText += 'Compras'
      break

    case AppPath.Reservations:
      headerText += 'Reservas'
      break

    case AppPath.Deals:
      headerText += 'Negocios'
      placeholder = 'Buscar por cliente, vehículo o patente'
      break

    case AppPath.Vehicles:
      placeholder = 'Buscar por vehículo'
      goTo = `/${AppPath.Vehicles}/edit/0`
      break

    case AppPath.Loans:
      headerText += 'Solicitudes de Crédito'
      break
    case AppPath.Messages:
      headerText += 'Mensajes'
      placeholder = 'Buscar por usuario, remitente o vehículo'
      crearButton = false
      break
    case AppPath.Users:
      headerText += 'Usuarios'
      placeholder = 'Buscar por usuario'
      goTo = `/${AppPath.Users}/edit/0`
      break
    case AppPath.Branches:
      headerText += 'Sucursales'
      placeholder = 'Buscar por sucursal'
      goTo = `/${AppPath.Branches}/edit/0`
      break
  }

  return (
    <div className="flex flex-col  p-4 bg-gray-100">
      <header className="mb-2">
        <h1 className="text-2xl font-bold">{headerText}</h1>
      </header>
      <div className="grid grid-cols-3 gap-x-4">
        <div className="max-w-sm flex items-center">
          <input
            type="text"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder={placeholder}
            className="w-full px-4 py-2 border rounded-l-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          />

          <button
            className="px-4 py-2 bg-blue-500 text-white rounded-r-lg hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500"
            onClick={handleClear}
          >
            Limpiar
          </button>
        </div>
        <div className="flex justify-center">{toolBar}</div>
        <div>{crearButton && showCreaButton && <ButtonAction label="Crear..." handleButtonClick={handleCrear} />}</div>
      </div>
    </div>
  )
}

export default CardOneSearch
